module.exports = ".type{\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n    font-size: 1.1rem;\n    color: rgb(80,80,80);\n    margin: 0 auto;\n    width: 90%;\n  }\n  \n  .mandatory{\n    color: red;\n  }\n  \n  .radioButton label{\n    padding: 0;\n  }\n  \n  input{\n   visibility: hidden;\n    width: 0px;\n    height: 0px;\n  }\n  \n  input, .radioButton label{\n    cursor: pointer;\n  }\n  \n  \n  \n  \n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/questions-type/emoji-type/emoji-type.component.css
// module id = ./src/app/questions-type/emoji-type/emoji-type.component.css
// module chunks = main